import { __decorate } from "tslib";
import { Component, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { WebsiteThemeService } from '../../services/website-theme.service';
import { DomSanitizer } from '@angular/platform-browser';
import { WebClientService } from '../../services/webclient-settings.service';
/**
 * Modal Component
 */
let PersonalModalComponent = class PersonalModalComponent {
    constructor(router, sanitizer, themeService, webSettingsService) {
        this.router = router;
        this.sanitizer = sanitizer;
        this.themeService = themeService;
        this.webSettingsService = webSettingsService;
        this.backColor = '';
        this.successColor = '';
        this.textColor = '';
        this.guestIsOn = false;
        this.mainColor = '';
        this.borderRadiusLarger = '';
        this.borderRadiusSmaller = '';
        this.themeService.getTheme().subscribe((data) => {
            this.backColor = this.themeService.getStyleAttribute('modal_back_color');
            this.successColor = this.themeService.getStyleAttribute('success_color');
            this.textColor = this.themeService.getStyleAttribute('text_color');
            this.mainColor = this.themeService.getStyleAttribute('main_color');
            this.borderRadiusLarger = this.themeService.getStyleAttribute('border_radius_larger');
            this.borderRadiusSmaller = this.themeService.getStyleAttribute('border_radius_smaller');
        });
        this.guestIsOn = this.webSettingsService.applySettings('GUEST_USER.ON');
    }
    close() {
        this.router.navigateByUrl('verify');
        this.modal.destroy();
    }
    goToVerificationPage(event) {
        if (event.target.tagName === 'A') {
            event.preventDefault();
            this.router.navigateByUrl('/verify');
            this.modal.destroy();
        }
    }
    closeModal() {
        this.modal.destroy();
    }
};
PersonalModalComponent.ctorParameters = () => [
    { type: Router },
    { type: DomSanitizer },
    { type: WebsiteThemeService },
    { type: WebClientService }
];
PersonalModalComponent = __decorate([
    Component({
        selector: 'ecd-personal',
        encapsulation: ViewEncapsulation.None,
        template: __importDefault(require("./personal-verification-modal.component.html")).default
    })
], PersonalModalComponent);
export { PersonalModalComponent };
